module.exports = __webpack_public_path__ + "img/buenos_aires_villa_crespo.ad2a2b3d.jpg";